import planificacion from '@/api/planificacion'
import DateService, { FMT } from '@/helpers/DateService'

const state = {
  planificaciones: []
}

const getters = {
  planificaciones: (state) => {
    return state.planificaciones
  },

  getPlanificacionByID: (state) => (id) => {
    return state.planificaciones.find(x => x.ID_PLANIFICACION_MEDIO.equalsIgnoreCase(id))
  }
}

const mutations = {
  SET_PLANIFICACIONES(state, planificaciones) {
    state.planificaciones = planificaciones
  },

  SOCKET_createPlanificacion(state, planificaciones) {
    planificaciones.forEach(planificacion => {
      state.planificaciones.push(planificacion)

      this.notify(
        'Nueva planificación',
        `Se ha añadido una nueva planificación para el día: ${
          DateService.toDayjs(planificacion.FECHA_ALARMADO_PLANIF).format(FMT.onlyDate)}`
      )
    })
  },

  SOCKET_updatePlanificacion(state, planificacion) {
    const index = state.planificaciones.findIndex(x => x.ID_PLANIFICACION_MEDIO.equalsIgnoreCase(planificacion.ID_PLANIFICACION_MEDIO))
    if (index !== -1) {
      state.planificaciones.splice(index, 1, {
        ...state.planificaciones[index],
        ...planificacion
      })
      this.notify(
        'Planificación actualizada',
        `Se ha actualizado la planificación para el día: ${DateService.toDayjs(planificacion.FECHA_ALARMADO_PLANIF).format(FMT.onlyDate)}`
      )
    }
  },

  SOCKET_deletePlanificacion(state, idPlanificacion) {
    const index = state.planificaciones.findIndex(x => x.ID_PLANIFICACION_MEDIO.equalsIgnoreCase(idPlanificacion))
    if (index !== -1) {
      state.planificaciones.splice(index, 1)
      this.notify(
        'Planificación eliminada',
        'Se ha eliminado correctamente la planificacion'
      )
    }
  }
}

const actions = {
  async fetchPlanificaciones({ commit }, params) {
    try {
      const response = await planificacion.getPlanificacionByDateRange(params.fechaInicio, params.fechaFinal)
      commit('SET_PLANIFICACIONES', response.data)
    } catch (err) {
      console.error('Error al obtener planificaciones', err)
      throw err
    }
  },

  async addPlanificacion({ commit }, data) {
    try {
      await planificacion.addPlanificacion(data)
    } catch (err) {
      console.error('Error al añadir planificacion', err)
      throw err
    }
  },

  async editPlanificacion({ commit }, data) {
    try {
      await planificacion.editPlanificacion(data)
    } catch (err) {
      console.error('Error al editar planificacion', err)
      throw err
    }
  },

  async deletePlanificacionById({ commit }, id) {
    try {
      await planificacion.deletePlanificacionById(id)
    } catch (err) {
      console.error('Error al eliminar planificacion', err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
